import { Component } from '@angular/core';
import { InfoPostNavConfig } from '../sidebar-nav/nav-menus.constants';
import { NavItemContainerUtilComponent } from 'shared/utils/nav-item-container-util.component';
@Component({
  selector: 'app-infopost-sidebar-nav-item',
  templateUrl: './sidebar-nav-item.component.html',
  styleUrls: ['./sidebar-nav-item.component.scss'],
})
export class InfoPostSidebarNavItemComponent extends NavItemContainerUtilComponent<InfoPostNavConfig> { }
